const DivisionList = () => import(/* webpackChunkName: 'wxmenu' */ './divisionList');
const AddDivision = () => import(/* webpackChunkName: 'wxmenu' */ './addDivision');

const routes = [
  { path: '/devide/divisionList', component: DivisionList, name: 'divisionList' },
  { path: '/devide/addDivision', component: AddDivision, name: 'addDivision' }
];

export default routes;
